import { useState } from "react";
import InfoModal from "../InfoModal";

// Asterisk next to a result that had a scratch. The result shown already has
// the deduction applied; clicking the asterisk explains it.
export default function ScratchAsterisk({ deduction, unit }) {
  const [isOpen, setIsOpen] = useState(false);
  const amount = Number(deduction);

  if (deduction == null || !(amount > 0)) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="font-medium text-gray-900 cursor-pointer"
        aria-label="Scratch deduction"
      >
        *
      </button>
      {/* Number() drops trailing zeros: 0.100 shows as 0.1 */}
      <InfoModal
        isOpen={isOpen}
        title="Scratch"
        description={`A deduction of ${amount} ${unit} was applied due to a scratch.`}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
}
